<span *ngIf="lookup_stores | async as stores">
  <ng-template [ngIf]="stores.length > 1">
    <div class="p-float-label">
      <p-dropdown [options]="stores" [filter]="true" (onChange)="onStoreChanged($event)" [(ngModel)]="selectedStoreId">
      </p-dropdown>
      <label>Change Store</label>
    </div>
  </ng-template>
</span>
